import { gql } from "@apollo/client/core";

export default gql`
    mutation DeleteSite($id: ID!) {
        deleteSite(input: { id: $id }) {
            errors
            status
            statusCode
        }
    }
`
